import { Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/atoms/ScrollToTop';
import HomePage from './pages/HomePage';
import Layout from './components/Layout';
import PersonasPage from './pages/PersonasPage';
import CommunityPage from './pages/CommunityPage';
import PricingPage from './pages/PricingPage';
import PersonaInitializer from './pages/PersonaInitializer';
import PersonalityTestPage from './pages/PersonalityTestPage';
import EditPersonaPage from './pages/EditPersonaPage';
import EditProfilePage from './pages/EditProfilePage';
import { AuthenticatedChatPage } from './pages/ChatPage';
import PublicPersonaPage from './pages/PublicPersonaPage';
import ShopPage from './pages/ShopPage';
import AccountSettingsPage from './pages/AccountSettingsPage';
import EgoProfilePage from './pages/EgoProfilePage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import DeveloperPage from './pages/DeveloperPage';
import FAQPage from './pages/FAQPage';

/**
 * Main application component. Defines the entire routing structure for the Ego Console.
 * The routes are split between the main authenticated application (nested under Layout)
 * and the public-facing persona pages.
 */
function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* --- Public Route (Handles logged-out users) --- */}
        <Route path="/" element={<HomePage />} />

        {/* --- Protected Application Routes --- */}
        <Route element={<Layout />}>
          <Route path="/passport" element={<EgoProfilePage />} />
          <Route path="/profiles" element={<PersonasPage />} />
          <Route path="/personality-test" element={<PersonalityTestPage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/settings" element={<AccountSettingsPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/developer" element={<DeveloperPage />} />
          <Route path="create-persona" element={<PersonaInitializer />} />
          <Route
            path="personas/edit/:personaId"
            element={<EditPersonaPage />}
          />
          <Route
            path="profiles/edit/:profileId"
            element={<EditProfilePage />}
          />
          <Route path="chat/:personaId" element={<AuthenticatedChatPage />} />
        </Route>

        {/* Public Persona Page Route */}
        <Route path="/p/:username" element={<PublicPersonaPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
    </>
  );
}

export default App;
